<template>
  <input
    class="input"
    :value="modelValue"
    v-on:change="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
    :placeholder="field.type"
  />
</template>

<script lang="ts">
import { type PropType, defineComponent } from 'vue'

import type { FloatUserConfigurationField } from '@/types/workerConfiguration'

export default defineComponent({
  emits: {
    'update:modelValue': (value: number | string) => ['string', 'number'].includes(typeof value),
  },
  props: {
    field: {
      type: Object as PropType<FloatUserConfigurationField>,
      required: true,
    },
    modelValue: {
      type: [String, Number],
      required: true,
    },
  },
})
</script>
